// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3blGS","paramInput":"JobSimulator_paramInput__1RkoX","input":"JobSimulator_input__1Al8S"};